import { render, staticRenderFns } from "./BigCommerce.vue?vue&type=template&id=88a76bb4&"
import script from "./BigCommerce.vue?vue&type=script&lang=js&"
export * from "./BigCommerce.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports